export const datosFiscalesForm = {
  rfc: {
      value: '',
      required: false,
      message: 'Dato requerido',
      tool: '',
      invalid: false,
  },
  razonSocial: {
    value: '',
    required: false,
    message: 'Dato requerido',
    tool: '',
    invalid: false,
  },
  folioOdc: {
    value: '',
    required: false,
    message: 'Dato requerido',
    tool: '',
    invalid: false,
  },
  cveUsoCfdi: {
    value: '',
    required: true,
    message: 'Dato requerido',
    tool: '',
    invalid: false,
  },
  cveFormaPago: {
    value: '',
    required: true,
    message: 'Dato requerido',
    tool: '',
    invalid: false,
  },
  cveMetodoPago: {
    value: '',
    required: false,
    message: 'Dato requerido',
    tool: '',
    invalid: false,
  },
  idRegimenFiscal: {
    value: ' ',
    required: true,
    message: 'Dato requerido',
    tool: ' ',
    invalid: false,
  },
}

export const datosFiscalesMinForm = {
  cveUsoCfdi: {
    value: '',
    required: true,
    message: 'Dato requerido',
    tool: '',
    invalid: false,
  },
  idRegimenFiscal: {
    value: '',
    required: true,
    message: 'Dato requerido',
    tool: ' ',
    invalid: false,
  },
}

export const datosFiscalesTerceroForm = {
  rfc: {
    value: '',
    required: true,
    message: 'RFC inválido o con espacio al final',
    tool: '',
    invalid: false,
  },
  idUsoCfdi: {
    value: '',
    required: true,
    message: 'Dato requerido',
    tool: '',
    invalid: false,
  },
  razonSocial: {
    value: '',
    required: true,
    message: 'Dato requerido',
    tool: '',
    invalid: false,
  },
  idRegimenFiscal: {
    value: '',
    required: true,
    message: 'Dato requerido',
    tool: ' ',
    invalid: false,
  },
  nombre: {
    value: '',
    required: true,
    message: 'Dato requerido',
    tool: '',
    invalid: false,
  }, 
  apellidoPaterno: {
    value: '',
    required: true,
    message: 'Dato requerido',
    tool: '',
    invalid: false,
  }, 
  apellidoMaterno: {
    value: '',
    required: true,
    message: 'Dato requerido',
    tool: '',
    invalid: false,
  }, 
  telefono: {
    value: '',
    required: true,
    message: 'Dato requerido',
    tool: '',
    invalid: false,
  }, 
  celular: {
    value: '',
    required: true,
    message: 'Dato requerido',
    tool: '',
    invalid: false,
  }, 
  correoElectronico: {
    value: '',
    required: true,
    message: 'Correo electónico no valido',
    tool: '',
    invalid: false,
  },
}

export const seleccionTerceroFrom = {
  idPersonaTercero: {
    value: '',
    required: true,
    message: 'Dato requerido',
    tool: '',
    invalid: false,
  },
}